import React from 'react';

import { Bloc } from '@mairistem/administres-utils';

import { useEntiteStore } from '@/zustand';
import ActeListeContainer from '@/components/Acte/Liste/ActeListeContainer';

interface BlocListeProps {
  style?: React.CSSProperties;
}

const BlocListe = (props: BlocListeProps) => {
  const { style } = props;
  const blocked = useEntiteStore((state) => state.blocked);

  if (blocked) {
    return null;
  }

  return (
    <Bloc icon="search" header="Rechercher un événement" style={style}>
      {/* Pas de « Voir tout » (AD-12900) : il n'a pas d'intérêt ici. */}
      <ActeListeContainer dashboard />
    </Bloc>
  );
};

export default BlocListe;
